export interface DraftType {
  id: string;
  name: string;
  description: string;
  category: string;
  created_by?: string;
  created_by_logo?: string;
  tags?: string[];
  last_updated?: string;
}

export interface DraftMetadata {
  draft_type_id: string;
  document_type_id: string;
  name: string;
  status: 'processing' | 'completed' | 'failed' | 'queued' | 'not_generated';
  generated_at: string;
  word_count: number;
  version: number;
  finalized?: boolean;
  finalized_at?: string;
  error_message?: string | null;
}

export interface MergedDraftItem {
  document_type_id: string;
  name: string;
  category: string;
  description: string;
  draftType: DraftType;
  latestVersion: DraftMetadata | null;
  allVersions: DraftMetadata[];
  status: 'available' | 'processing' | 'completed' | 'failed' | 'not_generated';
  version: number;
  finalized?: boolean;
  finalized_at?: string;
  isPonsCreated: boolean;
  isTemplateGenerated?: boolean;
}

export const formatCategoryName = (category: string): string => {
  return category
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const getStatusColor = (status: string): 'green' | 'blue' | 'red' | 'gray' | 'yellow' => {
  switch (status) {
    case 'completed':
      return 'green';
    case 'processing':
    case 'queued':
      return 'blue';
    case 'failed':
      return 'red';
    case 'available':
    case 'not_generated':
      return 'gray';
    default:
      return 'gray';
  }
};

export const getStatusLabel = (status: string, t: (key: string) => string): string => {
  switch (status) {
    case 'completed':
      return t('Completed');
    case 'processing':
      return t('Processing');
    case 'queued':
      return t('Queued');
    case 'failed':
      return t('Failed');
    case 'available':
      return t('Available');
    case 'not_generated':
      return t('Not Generated');
    default:
      return status;
  }
};
